import { render, staticRenderFns } from "./ToolZoomOut.vue?vue&type=template&id=50c5c6ee&scoped=true&"
var script = {}
import style0 from "./ToolZoomOut.vue?vue&type=style&index=0&id=50c5c6ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5c6ee",
  null
  
)

export default component.exports